import { Button, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { RASK_BOOK_DEMO_LINK } from '@/shared/constants/docLinks';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

export const EnterpriseBanner = () => {
  const handleBookDemo = () => {
    MixpanelEvents.trialPricingModalBookDemoClick();
    window.open(RASK_BOOK_DEMO_LINK, '_blank', 'noopener,noreferrer');
  };

  return (
    <Stack
      sx={{
        backgroundColor: 'grey.900',
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 16,
        width: '100%',
      }}
      alignItems="center"
      direction="row"
      gap={16}
      justifyContent="space-between"
      padding={24}
    >
      <Stack gap={8}>
        <Stack alignItems="center" direction="row" gap={8}>
          <Typography color="common.white" variant="title-4-sb">
            Enterprise
          </Typography>
          <Typography color="common.white" sx={{ opacity: 0.5 }} variant="body-2-md">
            Custom pricing
          </Typography>
        </Stack>
        <Typography color="common.white" variant="body-2-md">
          From 2,000,000 credits/month. Custom contracts, dedicated support, tailored to your needs.
        </Typography>
      </Stack>

      <Button
        sx={{ backgroundColor: 'common.white', flexShrink: 0 }}
        variant="outlined"
        onClick={handleBookDemo}
      >
        Book demo
      </Button>
    </Stack>
  );
};
